// src/v3/account/twitter.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var TwitterIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "TwitterIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M17.58 2.25h2.974l-6.499 8.26 7.646 11.24h-5.987l-4.689-6.817L5.66 21.75H2.683l6.952-8.835L2.3 2.25h6.139l4.238 6.23 4.902-6.23Zm-1.045 17.52h1.649L7.543 4.126H5.774L16.535 19.77Z"
  }
) });

export {
  TwitterIcon
};
